import React, { Component } from "react";
import loading from "./syndigo-loader.svg";

class Loading extends Component {
    render() {
        const style = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
            backgroundColor: "white",
        };

        return (
            <div style={style}>
                <img src={loading} alt="loading" style={{ maxWidth: "300px", maxHeight: "300px", marginBottom: "5px" }} />
                <span style={{ color: '#5e5e5e', fontSize: "14px", fontWeight: "bold" }}>LOADING</span>
            </div>
        );
    }
}

export default Loading;
